module.exports = __webpack_public_path__ + "img/5581.3a5d598d.jpg";